import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-cafe-resto-tunis',
  templateUrl: './cafe-resto-tunis.component.html',
  styleUrls: ['./cafe-resto-tunis.component.scss']
})
export class CafeRestoTunisComponent implements OnInit {

  public cafeTunis: any
  p: Number = 1;
  closeResult = '';
  public agencies:any
  search_name1:any;
  dataSource = new MatTableDataSource();
  public search: string  = ''

  constructor(private agenciesService: AgenciesService,
    
    private searchService: SearchService) { }
 ngOnInit(): void {
  this.cafeeTunis();
     
  }
  cafeeTunis() {
    this.agenciesService.getList().subscribe((data: any) => {
      this.cafeTunis = data;
      console.log('old data ', this.cafeTunis);
  
      // Filter agencies from Tunis with phone_number_commercial: "yes"
      this.agencies = this.cafeTunis.filter((agency: any) => {
        // Check if the agency is from Tunis and has phone_number_commercial set to "yes"
        return agency.region === 'tunis' && agency.phone_number_commercial === 'yes';
      });
  
      console.log('Filtered agencies from Tunis with phone_number_commercial: "yes"', this.agencies);
      
      // Perform any additional operations or call functions as needed
      // this.performSearch();
    });
  }
  
  
  

  deleteAgencies(agencie,i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
           this.cafeTunis.splice(i,1)
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);
        
        });
      }
    });
  }
// Méthode pour effectuer la recherche
performSearch() {
  this.cafeTunis = this.searchService.search(this.cafeTunis, this.search);
}
}
